module.exports = __webpack_public_path__ + "assets/img/donate-edit-title-bg.18252a89.png";